/**
 * อ่านข้อความ error จาก backend ให้ครบทุกรูปแบบที่ระบบนี้ส่งมา
 *  - 400/401/403/500 ผ่าน GlobalExceptionFilter → `errorDescription` (camelCase)
 *  - 404 controller ส่งเอง ไม่ผ่าน filter      → `error_description` (snake_case)
 *
 * เหตุที่ใช้ `??` ต่อกันแบบที่ doc แนะนำไม่ได้:
 *  - 401/403 ส่ง `errorDescription: ""` มา → `"" ?? x` คืน `""` ต้องเช็ค falsy ไม่ใช่ nullish
 *  - บาง endpoint ส่ง `error_description: "undefined"` (string ตัวอักษร) มา
 */
export const getApiErrorMessage = (
  error: any,
  fallback = "เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง"
): string => {
  // timeout / network down — axios ไม่มี response ให้อ่าน
  if (error?.code === "ECONNABORTED" || (error?.isAxiosError && !error?.response)) {
    return "การเชื่อมต่อใช้เวลานานเกินกำหนด กรุณาตรวจสอบผลลัพธ์ก่อนส่งซ้ำ";
  }

  const data = error?.response?.data ?? error;
  // `error` อยู่ท้ายสุดเพราะเป็น text อังกฤษ เช่น "Not Found"
  const found = [data?.errorDescription, data?.error_description, data?.message, data?.error].find(
    (value: any) => {
      if (typeof value !== "string") return false;
      const text = value.trim().toLowerCase();
      return text !== "" && text !== "undefined" && text !== "null";
    }
  );

  return (found as string) || fallback;
};

export const getApiErrorStatus = (error: any): number | undefined =>
  Number(error?.response?.status ?? error?.response?.data?.statusCode) || undefined;
